import React from "react";
import { Link } from "react-navi";
import siteMetadata from "../siteMetadata";
import styles from "./BlogFooter.module.css";

const menuLinks = [
  { label: "Dashboard", href: "https://voicetyping.xyz/dashboard/app" },
  { label: "Commands", href: "https://voicetyping.xyz/dashboard/commands" },
  { label: "Settings", href: "https://voicetyping.xyz/dashboard/settings" },
  { label: "Downloads", href: "https://voicetyping.xyz/dashboard/downloads" },
];

const aboutLinks = [
  { label: "Support", href: "https://forms.gle/Wi9LbfKstPpwkLh89" },
  { label: "Privacy & Policy", href: "https://voicetyping.xyz/privacy" },
  { label: "Terms & Conditions", href: "https://voicetyping.xyz/terms" },
  { label: "FAQ", href: "https://voicetyping.xyz/dashboard/help" },
];

function BlogFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <h2 className={styles.title}>VoiceTyping.xyz</h2>
          <p className={styles.description}>{siteMetadata.description}</p>
        </div>

        <div className={styles.columns}>
          <div className={styles.column}>
            <h3 className={styles.columnTitle}>Menu</h3>
            <ul className={styles.linkList}>
              {menuLinks.map(({ label, href }) => (
                <li key={href}>
                  <a href={href}>{label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.column}>
            <h3 className={styles.columnTitle}>About</h3>
            <ul className={styles.linkList}>
              {aboutLinks.map(({ label, href }) => (
                <li key={href}>
                  <a href={href}>{label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.column}>
            <h3 className={styles.columnTitle}>Blog</h3>
            <ul className={styles.linkList}>
              <li>
                <Link href="/">All posts</Link>
              </li>
              <li>
                <Link href="/tags">Tags</Link>
              </li>
              <li>
                <Link href="/about">About</Link>
              </li>
              <li>
                <a href="/rss.xml">RSS feed</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default BlogFooter;
